import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
// import { colors } from 'vuetify/lib';

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: "#261C84",
    secondary: "#262D91",
    accent: "#2856B0",
    white: "#FFF",
    yellow: "#FF0",
    red: "#F33",
    green: "#4E7",
    purple: "#F4F",
  }
})
